// Module
var code = "<div class=\"modal-footer button-bar\" ng-if=\"canShowTokenForm()\"> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"verify()\" ng-disabled=\"!verifyForm.tokenInput.$valid || !verifyForm.tokenInput.$dirty\"> Verify </button> <button type=\"button\" class=\"btn btn-link\" ng-click=\"$dismiss()\">Cancel</button> </div> ";
// Exports
module.exports = code;